import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { parseAsDateUTC, toISODatewithoutTimezone } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { DefaultFilter } from 'app/area/shared/default-filters/types-store';
import { mapFiltersToWire } from 'app/area/shared/default-filters/utils/map-filters';

import { mapSavedReportsToWire } from '../../common/map-saved-reports';
import { SavedReportDashboard } from '../../common/types-store';
import { defaultFilterDashboardConfig } from '../constants';
import { DashboardItem } from '../types-store';
import { DashboardItemWire } from '../types';

export const mapDashboardFromWire = (wire: Partial<DashboardItemWire>): DashboardItem => ({
  id: wire?.code?.v,

  language: wire?.language?.map(codeItemToStoreValue) ?? [],

  disabled: wire?.disabled
    ? parseAsDateUTC(wire.disabled)
    : undefined,
  sequence: wire?.sequence,

  accessType: isDefinedIncludingZero(wire?.accessType?.v)
    ? codeItemToStoreValue(wire.accessType)
    : undefined,

  subset: wire?.subset?.map(codeItemToStoreValue) ?? [],
  application: wire?.application?.map(codeItemToStoreValue) ?? [],
  person: wire?.person?.map(codeItemToStoreValue) ?? []
});

export const mapDashboardToWire = (
  dashboard: DashboardItem,
  savedReports: SavedReportDashboard[],
  filters: DefaultFilter[]
): DashboardItemWire => ({

  ...(isDefinedIncludingZero(dashboard?.id) && {
    code: {
      v: dashboard.id
    }
  }),

  language: dashboard?.language?.map(languageItem => ({
    v: languageItem.value,
    d: languageItem.description?.trim()
  })) ?? [],

  disabled: dashboard?.disabled
    ? toISODatewithoutTimezone(dashboard.disabled)()
    : undefined,

  sequence: dashboard?.sequence,

  accessType: isDefinedIncludingZero(dashboard?.accessType?.value)
    ? { v: dashboard.accessType?.value }
    : undefined,

  subset: dashboard?.subset?.map(subset => ({
    v: subset.value
  })) ?? [],
  application: dashboard?.application?.map(application => ({
    v: application.value
  })) ?? [],
  person: dashboard?.person?.map(person => ({
    v: person.value
  })) ?? [],

  savedReport: mapSavedReportsToWire(savedReports),

  filter: mapFiltersToWire(filters, defaultFilterDashboardConfig)
});
